import { Box, Flex, Text } from "@chakra-ui/react";
import React from "react";
import award from "../../../Assets/award2.svg";
import roboto from "@fontsource/roboto";

const Badge_Component = ({ num }) => {
  return (
    <div>
      <Flex
        paddingX={4}
        paddingY={2}
        borderRadius={47}
        border="1px solid #E7E6E8"
        align="center"
        w="-webkit-fit-content"
        gap={1}
      >
        <img style={{marginTop:"-3px"}} src={award} alt="badge" />
        <Text
          fontSize={[14,14,16,16]}
          fontWeight={500}
          fontFamily={"Roboto"}
          color="#544D5E"
        >
          {num}
        </Text>
      </Flex>
    </div>
  );
};

export default Badge_Component;
